import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

const pill = cva('inline-flex items-center h-[22px] px-2 rounded-chip text-[11.5px] font-bold whitespace-nowrap', {
  variants: {
    tone: {
      success: 'bg-success-bg text-success-fg', warning: 'bg-warning-bg text-warning-fg', notice: 'bg-notice-bg text-notice-fg',
      danger: 'bg-danger-bg text-danger-fg', neutral: 'bg-neutral-state-bg text-neutral-state-fg', accent: 'bg-accent-tint-bg text-accent-tint-fg',
    },
  },
  defaultVariants: { tone: 'neutral' },
});

/** Status pill: full-opacity ink on a tint, never faded text (Design Book §05). */
export function Pill({ tone, className, ...props }: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof pill>) {
  return <span className={cn(pill({ tone }), className)} {...props} />;
}
